/**
 * pick an item navigation data from sitemap
 * or fetch it from the backend
 */
const {
	generalSettings,
} = require("@parallelpublicworks/gatsby-clf/gatsby-options-index");

module.exports = async function fetchNavItem(_entity, fullSitemap = false, nid = 0) {
	let nav_item;
	let _sitemap;
	if (
		!nav_item &&
		((_entity && _entity.attributes && _entity.attributes.drupal_internal__nid) || nid)
	) {
		const _nid = nid || parseInt(_entity?.attributes?.drupal_internal__nid);

		/**
		 * if no sitemap available, fetch nav item from the backend
		 */
		let url = `${generalSettings.data.siteMetaData.drupalUrl}/jsonapi/build_nav/${_nid}?_format=json`;

		let get_nav = await fetch(url);
		if (get_nav.status === 200) {
			let get_nav_data = await get_nav.json();
			if (get_nav_data && get_nav_data.data) {
				_sitemap = get_nav_data.data;
				if (fullSitemap) return _sitemap;
				nav_item = _sitemap.find(({ nid }) => parseInt(nid) === parseInt(_nid));
			}
		}
	}
	if (nav_item) {
		return nav_item;
	} else {
		return;
	}
};
